import * as React from 'react';
import { ICommand } from '../../../models/commands/ICommand';
import { Facet } from '../../../models/Facet';
import { CreateFolderAction } from '../../actions/createFolder/CreateFolderAction';
import { getCommandIconProps } from '../getCommandIconProps';
import { FileIconType } from '@uifabric/file-type-icons/lib/index';
import CommandStrings from '../../scope/commands/commands.resx';
import { HideWithSelection } from '../../selectionVisibility/SelectionVisibility';

export const createFolderCommand: ICommand = {
  key: new Facet('createFolder').id,
  automationId: 'createFolderCommand',
  name: CommandStrings.CreateFolder,
  action: <HideWithSelection><CreateFolderAction /></HideWithSelection>,
  iconProps: getCommandIconProps({
    size: 16,
    type: 2 as FileIconType.folder
  }),
};
